import { __ } from '@wordpress/i18n';

const DashboardSubmenu = () => {
    const { imgDir, ratingUrl, forumUrl, documentationUrl } = window['JkitDashboardOption'];

    return (
        <div className="profecient-dashboard-submenu">
            <div className="profecient-dashboard-menu-item profecient-card">
                <div className="profecient-dashboard-menu-icon">
                    <img src={`${imgDir}/admin/documentation.png`}></img>
                </div>
                <div className="profecient-dashboard-menu-content">
                    <div className="description">
                        <h2 className="title">{__('Documentation', 'jeg-elementor-kit')}</h2>
                        <span>{__('Browse our collection of quick guides and tutorials to get the most out of Jeg Kit.', 'jeg-elementor-kit')}</span>
                        <a href={documentationUrl} target="_blank" rel="noreferrer">
                            <span>{__('View Docs', 'jeg-elementor-kit')}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div className="profecient-dashboard-menu-item profecient-card">
                <div className="profecient-dashboard-menu-icon">
                    <img src={`${imgDir}/admin/any-question.png`}></img>
                </div>
                <div className="profecient-dashboard-menu-content">
                    <div className="description">
                        <h2 className="title">{__('Any Questions?', 'jeg-elementor-kit')}</h2>
                        <span>{__('Our dedicated support team is ready to assist you with any questions or your problems.', 'jeg-elementor-kit')}</span>
                        <a href={forumUrl} target="_blank" rel="noreferrer">
                            <span>{__('Ask For Support', 'jeg-elementor-kit')}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div className="profecient-dashboard-menu-item profecient-card">
                <div className="profecient-dashboard-menu-icon">
                    <img src={`${imgDir}/admin/rate-plugin.png`}></img>
                </div>
                <div className="profecient-dashboard-menu-content">
                    <div className="description">
                        <h2 className="title">{__('Love the Plugin?', 'jeg-elementor-kit')}</h2>
                        <span>{__('Your review helps us grow and allows others to discover a tool they can trust.', 'jeg-elementor-kit')}</span>
                        <a href={ratingUrl} target="_blank" rel="noreferrer">
                            <span>{__('Rate Us', 'jeg-elementor-kit')}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardSubmenu;
